import { createFileRoute } from '@tanstack/react-router'
import { AdminFlagsPage } from '@/features/flags/pages/admin-flags-page'

export const Route = createFileRoute('/flags')({
  staticData: { title: 'Flags' },
  component: AdminFlagsPage,
})
